/**
 * 登录逻辑
 *
 * @file user.js
 * @author yangwei(yangwei14@baidu.com)
 */
import _ from 'lodash';
import {addActiveClass, isZH, redirect} from '../console/common/utils';
import client from '../client/index';

/**
 * 显示个人配置
 */
const showLogout = () => {
    let icon = $('.unlogin i') && $('.unlogin i')[0];
    let layer = $('.unlogin .layer') && $('.unlogin .layer')[0];
    addActiveClass(icon);
    addActiveClass(layer);
};

if (isZH) {
    (function () {
        let HEAD = document.getElementsByTagName('head')[0] || document.documentElement;
        let src = 'https://passport.baidu.com/passApi/js/uni_wrapper.js';
        let script = document.createElement('script');
        script.setAttribute('type', 'text/javascript');
        script.onload = function () {
            genIntance();
        };
        script.setAttribute('src', src);
        HEAD.appendChild(script);
        function genIntance() {
            let u = `${location.protocol}//${location.host}/console.html#/meeting/list`;
            // 会议管理页面登录跳转首页
            location.href.includes('console.html')
            && (u = `${location.protocol}//${location.host}/index.html`);
            // eslint-disable-next-line
            window.passPortInstance = passport.pop.init({
                apiOpt: {
                    staticPage: `${location.protocol}//${location.host}/v3Jump.html`, // jump地址，注意大小写
                    product: 'acgvideomeeting', // 产品线标志，原tpl
                    u: u, // 登录成功跳转地址
                    memberPass: true, // 记住登录状态，原isMen
                    safeFlag: 0
                },
                cache: true, //  缓存
                // img: '', //  产品图片 左侧
                forgetLink: 'https://passport.baidu.com/?getpass_index', // 忘记密码
                registerLink: 'https://passport.baidu.com/v2/?reg&tpl=&u=', // 注册链接
                authsite: ['tsina', 'wechat', 'fetion'], // 合作登录
                tangram: true, // 如果页面不是使用的tangram2.0， 则此处配置成true,否则配置成false
                onLoginSuccess: args => {
                }
            });
            window.passPortInstance.showLogout = showLogout;
            window.passPortInstance.logout = async function () {
                location.href = 'http://passport.baidu.com/?logout&u=https://videomeeting.baidu.com';
            };
            window.passPortInstance.change = function () {
                return;
            };
        }
    })();
}
else {
    // 国际化登录相关
    (function () {
        window.passPortInstance = {
            showLogout,
            logout: async function logout() {
                await client.signOutI18n();
                redirect('/');
            },
            change: function changePassword() {
                redirect('account.html#/change');
            }
        };
    })();
}

export const showLogin = () => {
    if (isZH) {
        if (_.get(window, 'passPortInstance.show')) {
            window.passPortInstance.show();
        }
    }
    else {
        window.location.href = '/account.html#/login';
    }
};
